import React, { useEffect, useState } from "react";
import {
    SearchIcon,
    IncomingIcon,
    CompletedIcon,
    RejectedIcon,
    PendingIcon,
} from "../../assets/svgs/Icons";
import { FiFilter } from "react-icons/fi";
import {
    Box,
    Button,
    Flex,
    Grid,
    GridItem,
    Input,
    InputGroup,
    InputLeftElement,
    Skeleton,
    Tab,
    Table,
    TableCaption,
    TableContainer,
    TabList,
    TabPanel,
    TabPanels,
    Tabs,
    Tbody,
    Td,
    Text,
    Tfoot,
    Th,
    Thead,
    Tr,
    Link,
    Select,
} from "@chakra-ui/react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { unwrapResult } from "@reduxjs/toolkit";

import {
    Column,
    useReactTable,
    ColumnFiltersState,
    getCoreRowModel,
    getFilteredRowModel,
    getFacetedRowModel,
    getFacetedUniqueValues,
    getFacetedMinMaxValues,
    getPaginationRowModel,
    sortingFns,
    getSortedRowModel,
    FilterFn,
    SortingFn,
    ColumnDef,
    flexRender,
    FilterFns,
    createColumnHelper,
} from "@tanstack/react-table";
import { rankItem } from "@tanstack/match-sorter-utils";
import moment from "moment/moment";
import { AiOutlineArrowLeft, AiOutlineArrowRight } from "react-icons/ai";
import isAllowed from "../../routing/isAllowed";
import { TriangleDownIcon, TriangleUpIcon } from "@chakra-ui/icons";

import { getApprovedShipments, getOutgoingTCs } from "./TransactionCertificateSlice";

const ApprovedShipments = () => {
    const [status, setStatus] = useState("idle");
    const { incomingTCs, isloading } = useSelector(
        (state) => state.transactionCertificateClient
    );
    const { userData } = useSelector((state) => state.auth);
    const dispatch = useDispatch();

    const [columnFilters, setColumnFilters] = useState([]);
    const [updatedData, setUpdatedData] = useState([]);
    const [isDataLoading, setIsDataLoading] = useState(false);
    const [globalFilter, setGlobalFilter] = useState("");
    const navigate = useNavigate();

    ;
    let companyId = userData?.companyId;

    const getList = () => {
        try {
            setStatus("pending");
            dispatch(getApprovedShipments(companyId));
            setStatus("success");
        } catch (error) {
            setStatus("failed");
            console.error(error);
        }
    };

    const updateIncomingData = () => {
        const updatedData = incomingTCs?.map((d, index) => {
            return {
                ...d,
                srNo: index + 1,
                actions: "actions",
                date: `${moment(d?.createdAt).format("DD-MM-YYYY")}`,
            };
        });
        setUpdatedData(updatedData);
    };

    const columnHelper = createColumnHelper();

    const columns = [
        columnHelper.accessor("srNo", {
            cell: (info) => info.getValue(),
            header: "srNo",
        }),
        columnHelper.accessor("date", {
            cell: (info) => info.getValue(),
            header: "Date",
            sortType: (a, b) => {
                var a1 = new Date(a).getTime();
                var b1 = new Date(b).getTime();
                if (a1 < b1) return 1;
                else if (a1 > b1) return -1;
                else return 0;
            }
        }),
        columnHelper.accessor("tc_seller.name", {
            cell: (info) => info.getValue(),
            header: "Seller Details",
        }),
        columnHelper.accessor("tcApplicationNumber", {
            cell: (info) => info.getValue(),
            header: "TC Number",
            // meta: {
            //   isNumeric: true,
            // },
        }),
        columnHelper.accessor("totalGrossWeight", {
            cell: (info) => info.getValue(),
            header: "Gross Weight (kg)",
            // meta: {
            //   isNumeric: true,
            // },
        }),
        columnHelper.accessor("totalNetWeight", {
            cell: (info) => info.getValue(),
            header: "Net Weight (kg)",
            // meta: {
            //   isNumeric: true,
            // },
        }),
        columnHelper.accessor("totalCertifiedWeight", {
            cell: (info) => info.getValue(),
            header: "Certified Weight (kg)",
            // meta: {
            //   isNumeric: true,
            // },
        }),
        columnHelper.accessor("status", {
            cell: (info) => info.getValue(),
            header: "Status",
            // meta: {
            //   isNumeric: true,
            // },
        }),
        columnHelper.accessor("actions", {
            cell: (info) => info.getValue(),
            header: "Action",
            // meta: {
            //   isNumeric: true,
            // },
        }),
    ];

    const fuzzyFilter = (row, columnId, value, addMeta) => {
        // Rank the item
        const itemRank = rankItem(row.getValue(columnId), value);
        // Store the itemRank info
        addMeta({
            itemRank,
        });
        // Return if the item should be filtered in/out
        return itemRank.passed;
    };

    const table = useReactTable({
        data: updatedData || [],
        columns,
        filterFns: {
            fuzzy: fuzzyFilter,
        },
        state: {
            columnFilters,
            globalFilter,
        },
        onColumnFiltersChange: setColumnFilters,
        onGlobalFilterChange: setGlobalFilter,
        globalFilterFn: fuzzyFilter,
        getCoreRowModel: getCoreRowModel(),
        getFilteredRowModel: getFilteredRowModel(),
        getSortedRowModel: getSortedRowModel(),
        getPaginationRowModel: getPaginationRowModel(),
        // getFacetedRowModel: getFacetedRowModel(),
        // getFacetedUniqueValues: getFacetedUniqueValues(),
        // getFacetedMinMaxValues: getFacetedMinMaxValues(),
        debugTable: true,
        debugHeaders: true,
        debugColumns: false,
    });

    useEffect(() => {
        getList();
    }, []);

    useEffect(() => {
        updateIncomingData();
    }, [incomingTCs]);

    ;

    ;
    return (
        <Box>
            {incomingTCs?.length > 0 ? (
                <>
                    <Box marginTop={"3rem"}>
                        <Flex mb="1rem" flexDirection={"row"}>
                            <Text> Transaction Certificate /</Text>
                            <Text fontWeight={"bold"}>Incoming Shipments</Text>
                        </Flex>
                        <Flex justifyContent="space-between" alignItems="center">
                            <Box>
                                <InputGroup>
                                    <InputLeftElement
                                        height={"100%"}
                                        pointerEvents="none"
                                        children={<SearchIcon w="28" h="28" color="#B8DEF8" />}
                                    />
                                    <Input
                                        type="text"
                                        color={"#464C64"}
                                        bg={"#fff"}
                                        w={"500px"}
                                        h={"48px"}
                                        value={globalFilter ?? ""}
                                        placeholder="Search All Results"
                                        onChange={(e) => setGlobalFilter(e.target.value)}
                                        fontSize={"14px"}
                                        borderRadius={"10px"}
                                        _placeholder={{
                                            opacity: 1,
                                            color: "#464C64",
                                            fontSize: "14px",
                                        }}
                                    />
                                </InputGroup>
                            </Box>
                            <Box>
                                <Box display={"flex"} justifyContent="space-between">
                                    <Box>
                                        <Box
                                            display={"flex"}
                                            alignItems="center"
                                            marginBottom={"10px"}
                                        >
                                            <Box
                                                as="span"
                                                display="flex"
                                                alignItems="center"
                                                gap="5px"
                                                marginRight={"10px"}
                                            >
                                                <Box as="span" width={"30%"}>
                                                    {" "}
                                                    Go to page:{" "}
                                                </Box>
                                                <Input
                                                    w={"60%"}
                                                    type="number"
                                                    color={"#464C64"}
                                                    bg={"#fff"}
                                                    defaultValue={
                                                        table.getState().pagination.pageIndex + 1
                                                    }
                                                    onChange={(e) => {
                                                        const page = e.target.value
                                                            ? Number(e.target.value) - 1
                                                            : 0;
                                                        table.setPageIndex(page);
                                                    }}
                                                />
                                            </Box>
                                            <Box>
                                                <Select
                                                    bg="#fff"
                                                    value={table.getState().pagination.pageSize}
                                                    onChange={(e) => {
                                                        table.setPageSize(Number(e.target.value));
                                                    }}
                                                >
                                                    {[10, 20, 30, 40, 50].map((pageSize) => (
                                                        <option key={pageSize} value={pageSize}>
                                                            Show {pageSize}
                                                        </option>
                                                    ))}
                                                </Select>
                                            </Box>
                                        </Box>
                                    </Box>
                                </Box>
                            </Box>
                        </Flex>
                    </Box>
                    <Box marginTop={"2rem"}>
                        <Box
                            as="span"
                            display="flex"
                            alignItems="center"
                            marginBottom={"10px"}
                            gap="5px"
                        >
                            <div>Page</div>
                            <strong>
                                {table.getState().pagination.pageIndex + 1} of{" "}
                                {table.getPageCount()}
                            </strong>
                        </Box>
                        <Tabs size="md" variant="enclosed">
                            <Table bg="brand.white" borderRadius="15px">
                                <Thead fontStyle={"normal"}>
                                    {table.getHeaderGroups().map((headerGroup) => (
                                        <Tr key={headerGroup.id}>
                                            {headerGroup.headers.map((header) => {
                                                // see https://tanstack.com/table/v8/docs/api/core/column-def#meta to type this correctly
                                                const meta = header.column.columnDef.meta;
                                                return (
                                                    <Th
                                                        key={header.id}
                                                        color="brand.blue"
                                                        textTransform="capitalize"
                                                        onClick={header.column.getToggleSortingHandler()}
                                                        isNumeric={meta?.isNumeric}
                                                    >
                                                        {flexRender(
                                                            header.column.columnDef.header,
                                                            header.getContext()
                                                        )}
                                                        <Box as="span" pl="1rem">
                                                            {console.log({
                                                                sort: header.column.getIsSorted(),
                                                            })}
                                                            {header.column.getIsSorted() ? (
                                                                header.column.getIsSorted() === "desc" ? (
                                                                    <TriangleDownIcon
                                                                        aria-label="sorted descending"
                                                                        color={"#3958DC"}
                                                                        size="20"
                                                                    />
                                                                ) : (
                                                                    <TriangleUpIcon
                                                                        aria-label="sorted ascending"
                                                                        color={"#3958DC"}
                                                                        size="20"
                                                                    />
                                                                )
                                                            ) : null}
                                                        </Box>
                                                    </Th>
                                                );
                                            })}
                                        </Tr>
                                    ))}
                                </Thead>
                                <Tbody>
                                    {isloading ? (
                                        <>
                                            <Tr>
                                                <Td>
                                                    <Skeleton height="20px" fadeDuration={1} />
                                                </Td>
                                                <Td>
                                                    <Skeleton height="20px" fadeDuration={1} />
                                                </Td>
                                                <Td>
                                                    <Skeleton height="20px" fadeDuration={1} />
                                                </Td>
                                                <Td>
                                                    <Skeleton height="20px" fadeDuration={1} />
                                                </Td>
                                                <Td>
                                                    <Skeleton height="20px" fadeDuration={1} />
                                                </Td>
                                            </Tr>
                                            <Tr>
                                                <Td>
                                                    <Skeleton height="20px" fadeDuration={1} />
                                                </Td>
                                                <Td>
                                                    <Skeleton height="20px" fadeDuration={1} />
                                                </Td>
                                                <Td>
                                                    <Skeleton height="20px" fadeDuration={1} />
                                                </Td>
                                                <Td>
                                                    <Skeleton height="20px" fadeDuration={1} />
                                                </Td>
                                                <Td>
                                                    <Skeleton height="20px" fadeDuration={1} />
                                                </Td>
                                            </Tr>
                                            <Tr>
                                                <Td>
                                                    <Skeleton height="20px" fadeDuration={1} />
                                                </Td>
                                                <Td>
                                                    <Skeleton height="20px" fadeDuration={1} />
                                                </Td>
                                                <Td>
                                                    <Skeleton height="20px" fadeDuration={1} />
                                                </Td>
                                                <Td>
                                                    <Skeleton height="20px" fadeDuration={1} />
                                                </Td>
                                                <Td>
                                                    <Skeleton height="20px" fadeDuration={1} />
                                                </Td>
                                            </Tr>
                                            <Tr>
                                                <Td>
                                                    <Skeleton height="20px" fadeDuration={1} />
                                                </Td>
                                                <Td>
                                                    <Skeleton height="20px" fadeDuration={1} />
                                                </Td>
                                                <Td>
                                                    <Skeleton height="20px" fadeDuration={1} />
                                                </Td>
                                                <Td>
                                                    <Skeleton height="20px" fadeDuration={1} />
                                                </Td>
                                                <Td>
                                                    <Skeleton height="20px" fadeDuration={1} />
                                                </Td>
                                            </Tr>
                                        </>
                                    ) : (
                                        <>
                                            {table.getRowModel()?.rows?.map((row) => (
                                                <Tr key={row?.id}>
                                                    {row.getVisibleCells().map((cell) => {
                                                        // see https://tanstack.com/table/v8/docs/api/core/column-def#meta to type this correctly
                                                        const meta = cell?.column?.columnDef?.meta;
                                                        return (
                                                            <Td
                                                                key={cell?.id}
                                                                isNumeric={meta?.isNumeric}
                                                                fontWeight={500}
                                                                fontSize="sm"
                                                            >
                                                                {cell?.renderValue() === "actions" ? (
                                                                    <Link
                                                                        color={"#3958DC"}
                                                                        fontWeight="800"
                                                                        onClick={() =>
                                                                            navigate(
                                                                                `/client/transaction-certificates/tc-details/${encodeURIComponent(
                                                                                    cell?.row?.original?.id
                                                                                )}`
                                                                            )
                                                                        }
                                                                    >
                                                                        View Details
                                                                    </Link>
                                                                ) : (
                                                                    flexRender(
                                                                        cell?.column?.columnDef?.cell,
                                                                        cell?.getContext()
                                                                    )
                                                                )}
                                                            </Td>
                                                        );
                                                    })}
                                                </Tr>
                                            ))}
                                        </>
                                    )}
                                </Tbody>
                            </Table>
                            <Box
                                display={"flex"}
                                justifyContent="center"
                                marginTop={"1rem"}
                                marginBottom="2rem"
                            >
                                <Box display={"flex"} gap="2rem">
                                    <Button
                                        className="border rounded p-1"
                                        bg="#52BBFF"
                                        _hover={{ bg: "#52BBFF" }}
                                        onClick={() => table.previousPage()}
                                        disabled={!table.getCanPreviousPage()}
                                    >
                                        <AiOutlineArrowLeft color="#141D43" size={18} />
                                    </Button>
                                    <Button
                                        className="border rounded p-1"
                                        bg="#52BBFF"
                                        _hover={{ bg: "#52BBFF" }}
                                        onClick={() => table.nextPage()}
                                        disabled={!table.getCanNextPage()}
                                    >
                                        <AiOutlineArrowRight color="#141D43" size={18} />
                                    </Button>
                                </Box>
                            </Box>
                        </Tabs>
                    </Box>
                </>
            ) : (
                <Box
                    display={"flex"}
                    alignItems="center"
                    marginTop={"8rem"}
                    justifyContent="center"
                >
                    <Text fontSize={"25px"} fontWeight={"bold"} textAlign="center">
                        There are no Approved Shipments yet
                    </Text>
                </Box>
            )}
        </Box>
    );
};

export default ApprovedShipments;
